import React, { FC } from 'react';
import cn from 'classnames/bind';

import { SoundTracksList } from '@/scenarios/legacy-player/components/PlayerSkin/parts/SoundTracksList/SoundTracksList';
import { useSoundQualityTracks } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/SoundQuality/useSoundQualityTracks';
import { AudioTrack } from '@/scenarios/legacy-player/types/instance';

import styles from '../Tracks.module.css';

const cx = cn.bind(styles);

interface Props {
    onSelectAudioTrack: (track: AudioTrack) => void;
}

export const SoundQuality: FC<Props> = ({ onSelectAudioTrack }) => {
    const { currentTrack, qualityTracks, handleSelectSoundTrack } = useSoundQualityTracks({
        onSelectAudioTrack,
    });

    return (
        <SoundTracksList
            className={cx('sound')}
            titleClassName={cx('title')}
            currentSoundTrack={currentTrack}
            soundTracksWithNotes={qualityTracks}
            handleSelectSoundTrack={handleSelectSoundTrack}
        />
    );
};
